import React, { Component } from "react"

class Button extends Component {
  render() {
    return <button>I'm a test -child component- button</button>
  }
}

export default Button
